import { createSlice, createAsyncThunk, createAction } from "@reduxjs/toolkit";
import TourismPolicyService from "./TourismPolicyService";


export const getTourismPolicys = createAsyncThunk("TourismPolicy/get-TourismPolicys", async (thunkAPI) => {
  try {
    return await TourismPolicyService.getTourismPolicys();
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
}); 
export const createTourismPolicys = createAsyncThunk(
  "TourismPolicy/create-TourismPolicys",
  async (TourismPolicyData, thunkAPI) => {
    try {
      return await TourismPolicyService.createTourismPolicys(TourismPolicyData);
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const getTourismPolicy = createAsyncThunk(
  "TourismPolicy/get-TourismPolicy",
  async (id, thunkAPI) => {
    try {
      return await TourismPolicyService.getTourismPolicy(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const updateTourismPolicy = createAsyncThunk(
  "TourismPolicy/update-TourismPolicy",
  async (brand, thunkAPI) => {
    try {
      return await TourismPolicyService.updateTourismPolicy(brand);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const deleteATourismPolicy = createAsyncThunk(
  "TourismPolicy/delete-TourismPolicy",
  async (id, thunkAPI) => {
    try {
      return await TourismPolicyService.deleteTourismPolicy(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const resetState = createAction("Reset_all");

const initialState = {
  TourismPolicys: [],
  isError: false,
  isLoading: false,
  isSuccess: false,
  message: "",
};
export const TourismPolicySlice = createSlice({
  name: "TourismPolicy",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getTourismPolicys.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getTourismPolicys.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.TourismPolicys = action.payload.data;
      })
      .addCase(getTourismPolicys.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(createTourismPolicys.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createTourismPolicys.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.createdTourismPolicy = action.payload;
      })
      .addCase(createTourismPolicys.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.payload;
      })
      .addCase(getTourismPolicy.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getTourismPolicy.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.associationName= action.payload.data.policyName;
        state.associationpolicyDetails= action.payload.data.policyDetails; 
      })
      .addCase(getTourismPolicy.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(updateTourismPolicy.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateTourismPolicy.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.updatedTourismPolicy = action.payload;
      })
      .addCase(updateTourismPolicy.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(deleteATourismPolicy.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteATourismPolicy.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.deletedTourismPolicy = action.payload;
      })
      .addCase(deleteATourismPolicy.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(resetState, () => initialState);
  },
});
export default TourismPolicySlice.reducer;
